<template>
  <div class="page-detail orders-dinner-create" v-loading="loading">
    <div class="title">
      下单
      <div>
        流程：
        <span :class="{active: step === 1}">1. 选择餐厅和菜品</span>
        <i>－</i>
        <span :class="{active: step === 2}">2. 确认订单信息</span>
        <i>－</i>
        <span>3. 提交订单</span>
        <div class="top-money-container">
          <span class="top-money">
            个人账户余额:
            <span class="money-detail">{{olderMoney.person}}</span>元
          </span>
          <span class="top-money">
            基础补助余额:
            <span class="money-detail">{{olderMoney.grant}}</span>元
          </span>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="info-block service-target">
        <div class="title">服务对象信息</div>
        <div class="sub-info row">
          <div class="field">
            <div class="label">老人信息</div>
            <div class="text">
              <div class="field">
                <div class="label">姓名</div>
                <div class="text">{{info.name}}</div>
              </div>
              <div class="field">
                <div class="label">手机号</div>
                <div class="text">{{info.phone}}</div>
              </div>
              <div class="field">
                <div class="label">身份证</div>
                <div class="text">{{info.idCard}}</div>
              </div>
              <div class="field">
                <div class="label">年龄</div>
                <div class="text">{{info.age}}</div>
              </div>
              <div class="field">
                <div class="label">性别</div>
                <div class="text">{{info.gender === '1' ? '女' : '男'}}</div>
              </div>
              <div class="field">
                <div class="label">老人类型</div>
                <div class="text">{{getNameOfOldManType(info.type)}}</div>
              </div>
              <div class="field">
                <div class="label">地址</div>
                <div class="text">{{info.residenceAddress}}</div>
              </div>
              <div class="field">
                <div class="label">标签</div>
                <div class="text">{{info.tagNames}}</div>
              </div>
            </div>
          </div>
          <div class="field">
            <div class="label">子女信息</div>
            <div class="text">
              <div class="field" v-for="item in contacts" :key="item.gid">
                <div class="label">{{item.name}}</div>
                <div class="text">
                  <span>{{item.relationship}}</span>
                  <span>{{item.phone}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="info-block service-info">
        <div class="title">订餐信息</div>
        <div class="sub-info edit">
          <div class="field">
            <div class="label">选择餐厅</div>
            <div class="text">
              <el-button type="default" v-if="step === 1" size="mini" @click="selectService">选择餐厅</el-button>
              <p class="service-business-info" v-if="provider">
                <span>{{provider.providerName}}</span>
                <span>地址：{{provider.address}}</span>
                <span>电话：{{provider.cTelPhone}}</span>
              </p>
            </div>
          </div>
          <div class="field">
            <div class="label">选择菜品</div>
            <div class="text">
              <el-button type="default" v-if="step === 1" size="mini" @click="selectMenu">选择菜品</el-button>
              <table class="menu-table" v-if="selectedItems.length > 0">
                <tbody>
                  <div v-for="(item, idx) in selectedItems" :key="item.gid">
                    <tr v-for="(skus, iSku) in item.sku" :key="iSku">
                      <td>{{idx|getIndex(iSku,selectedItems)}}</td>
                      <td>{{item.serviceName}}</td>
                      <td>{{item.sku && item.sku.name}}{{skus && skus.name}}</td>
                      <td>{{skus.count}}</td>
                      <td>{{(skus && skus.price || 0) * skus.count}}元</td>
                      <td>
                        <i v-if="step === 1" @click="removeItem(idx)" class="el-icon-close"></i>
                      </td>
                    </tr>
                  </div>
                  <tr>
                    <td colspan="4">配送费</td>
                    <td colspan="2">2元</td>
                  </tr>
                  <tr>
                    <td colspan="6">总价：{{totalPrice + 2}}元</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="sub-info edit">
          <div class="field">
            <div class="label">送餐时间</div>
            <div class="text">
              <service-time-selector :times="times" v-if="step === 1" :source-object="remark"></service-time-selector>
              <template v-else>{{remark.date}}&nbsp;{{remark.time}}</template>
            </div>
          </div>
          <div class="field">
            <div class="label">送餐地址</div>
            <div class="text">
              <el-input v-model="remark.addr" disabled v-if="step === 1" size="mini"></el-input>
              <template v-else>{{remark.addr}}</template>
            </div>
          </div>
          <div class="field">
            <div class="label">联系电话</div>
            <div class="text">
              <el-input v-model="remark.tel" v-if="step === 1" size="mini"></el-input>
              <template v-else>{{remark.tel}}</template>
            </div>
          </div>
          <div class="field">
            <div class="label">备注</div>
            <div class="text">
              <el-input v-model="remark.remark" v-if="step === 1" size="mini"></el-input>
              <template v-else>{{remark.remark}}</template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="actions">
      <el-button type="primary" size="small" v-if="step === 1" @click="doNext">下一步</el-button>
      <template v-else>
        <el-button type="default" size="small" @click="step = 1">上一步</el-button>
        <el-button type="primary" size="small" @click="submit">提交订单</el-button>
      </template>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import qs from 'qs'
import ServiceTimeSelector from '@/components/partial/ServiceTimeSelector'
import { mapState } from "vuex"
export default {
  filters: {
    getIndex(idx, skuIndex, selectedItems) {
      let index = 0;
      if (selectedItems) {
        for (let i = 0; i < selectedItems.length; i++) {
          if (i == idx) {
            index += (skuIndex + 1);
            return index;
          } else {
            index += selectedItems[i].sku.length;
          }
        }
      }
      return index;
    }
  },
  components: { ServiceTimeSelector },
  data() {
    return {
      olderMoney: {},
      loading: false,
      step: 1,
      info: {},
      contacts: [],
      provider: null,
      selectedItems: [],
      tempTotal: 0,
      remark: {
        time: '',
        addr: '',
        tel: '',
        remark: ''
      },
      times: ['10:30-11:30', '11:30-12:30', '12:30-13:30']
    }
  },
  computed: {
    totalPrice() {
      let total = 0
      for (let item of this.selectedItems) {
        for (let sku of item.sku) {
          total += (sku.count || 0) * (sku.price || 0);
        }
      }
      this.tempTotal = total
      return total
    },
    tel() {
      return this.$route.query.tel || '18605109311'
    },
    olderGid() {
      return this.$route.query.oneOldGid || ''
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    removeItem(idx) {
      this.selectedItems.splice(idx, 1)

      let item = _.find(this.selectedItems, e => e.gid === row.gid)
      let sku = item.sku;
      sku[skuIndex].count = 0;
      this.$set(this.selectedIdCountMap, item.sku[skuIndex].gid, 0)
      this.$set(item, 'sku', sku);
    },
    loadData() {
      this.loading = true
      //获取老人账户余额
      // 老人详细信息
      if (this.olderGid) {
        this.Service.call('theold/detail', 'GET', { gid: this.olderGid }).then(data => {
          if (data && data.gid) {
            this.info = data
            this.remark.addr = data.householdRegister
            this.remark.tel = data.phone || ''
            this.Service.call('usercontact', 'GET', { gid: this.info.gid }).then(data => {
              this.contacts = data || []
              this.Service.call('theoldstatistics/account', 'GET', { theOldGid: this.olderGid }).then(res => {
                this.olderMoney = { ...res }
              })
            }).catch(() => { }).finally(() => {
              this.loading = false
            })
          } else {
            this.loading = false
            this.routeReplace('/orders/service')
          }
        }).catch(() => {
          this.loading = false
          this.routeReplace('/orders/service')
        })
      }
      else if (this.tel) {
        this.Service.call('theold/detail/byphone', 'GET', { phone: this.tel }).then(data => {
          if (data && data.gid) {
            this.info = data
            this.remark.addr = data.householdRegister
            this.remark.tel = data.phone || ''
            this.Service.call('usercontact', 'GET', { gid: this.info.gid }).then(data => {
              this.contacts = data || []
              this.Service.call('theoldstatistics/account', 'GET', { theOldGid: this.info.gid }).then(res => {
                this.olderMoney = { ...res }
              })
            }).catch(() => { }).finally(() => {
              this.loading = false
            })
          } else {
            this.loading = false
            this.routeReplace('/orders/service')
          }
        }).catch(() => {
          this.loading = false
          this.routeReplace('/orders/service')
        })
      }
    },
    selectService() {
      this.modal('SelectRestaurantModal', this.info.gid).promise.then(service => {
        if (service) {
          this.provider = service
        }
      })
    },
    selectMenu() {
      if (!this.provider) {
        this.$message.error('请先选择餐厅')
        return
      }
      this.modal('SelectMenuItemsModal', this.provider, this.selectedItems).promise.then(selectedItems => {
        if (selectedItems) {
          this.selectedItems = [];
          this.selectedItems = selectedItems;
        }
      })
    },
    doNext() {
      if (!this.provider) {
        this.$message.error('请选择餐厅')
        return
      }
      if (!this.selectedItems.length) {
        this.$message.error('请选择菜品')
        return
      }
      if (!this.remark.date) {
        this.$message.error('请填写预约开始日期')
        return
      }
      if (!this.remark.time) {
        this.$message.error('请填写预约开始时间')
        return
      }
      if (!this.remark.addr) {
        this.$message.error('请填写服务地址')
        return
      }
      if (!this.remark.tel) {
        this.$message.error('请填写联系电话')
        return
      }
      this.step = 2
    },
    submit() {
      if (this.loading == true) {
        return;
      }
      let remark = [this.remark.date + ',' + this.remark.time || '', this.remark.addr || '', this.remark.tel || '', this.remark.remark || ''].join(',')
      let data = _.map(this.selectedItems, e => {
        let skus = _.map(e.sku, element => {
          return {
            serviceItemSkuGid: element.gid,
            serviceItemSkuName: e.serviceName + element.name,
            num: element.count || 1
          }
        });
        return {
          serviceItemGid: e.gid,
          serviceItemName: e.serviceName,
          remark,
          skus: skus
        }
      });
      this.loading = true
      this.Service.call('order', 'POST', qs.stringify({
        type: 3,
        serviceItemSkus: JSON.stringify(data),
        theOldGid: this.info.gid
      }), null, null, 'json', 'application/x-www-form-urlencoded').then((res) => {
        if (res.data.code === 0) {
          this.$message.success('订单提交成功')
          this.$router.push('/orders/service')
        } else {
          this.$message.error(`订单提交失败:${res.data.des}`)
        }
      }).finally(() => {
        this.loading = false
      })
    }
  },
  watch: {
    provider() {
      this.selectedItems = []
    },
    '$route'() {
      this.loadData()
    }
  }
}
</script>
<style lang="scss" scoped>
.top-money-container {
  display: inline-block;
  border-left: 2px solid #909399;
  margin-left: 20px;
  .top-money {
    margin-left: 25px;
    color: black;
    .money-detail {
      font-weight: bold;
      font-size: 16px;
      color: #67c23a;
    }
  }
}
</style>
